// Meta accepts phone numbers without + or any characters other than digits.
export function toMetaPhone(rawPhone: string): string | null {
  return rawPhone.replace(/\D/g, '') || null
}
